export const API_BASE_URL ='http://localhost:10000'
export const API_PROD_BASE_URL =  'https://api.erp.logisxl.com'
